module.exports = ".submit-btn-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n\n.img-responsive {\n  width: 100%;\n}\n\n.mt-5 {\n  margin-top: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/upload-project-offer-images/upload-project-offer-images.component.css
// module id = ./src/app/upload-project-offer-images/upload-project-offer-images.component.css
// module chunks = main